// sample_product_class_list({
//     type: 2,
//     key_word: search_name.value,
//   }).then((res) => {
//     if (res.code == 200) {
//       list.value = list_format(res.data.list);
//       console.log("打印list.value===", list.value);
//       current_item.value = list.value[0];
//       current_index.value = 0;
//     }
//   });
import { defineStore } from 'pinia';
import store from '@/store';
import { sample_product_class_list } from '@/api/apis';
export var useSampleStore = defineStore('useSampleStore', () => {
  var supplies_type_list = ref([]);
  var page = ref(1);
  var tag_status = ref(4);
  function get_supplies_type() {
    return new Promise((resolve, reject) => {
      if (supplies_type_list.value.length != 0) {
        resolve(supplies_type_list.value);
      } else {
        sample_product_class_list({
          type: 2,
          key_word: ''
        }).then(res => {
          if (res.code == 200) {
            supplies_type_list.value = res.data.list;
            resolve(supplies_type_list.value);
          }
        });
      }
    });
  }
  function SetTagStatus(status) {
    tag_status.value = status;
  }
  return {
    supplies_type_list,
    get_supplies_type,
    page,
    tag_status,
    SetTagStatus
  };
});

// 非setup
export function useSampleStoreHook() {
  return useSampleStore(store);
}